import { render, staticRenderFns } from "./scatter.md?vue&type=template&id=3fe46919&"
import script from "./scatter.md?vue&type=script&lang=js&"
export * from "./scatter.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fe46919')) {
      api.createRecord('3fe46919', component.options)
    } else {
      api.reload('3fe46919', component.options)
    }
    module.hot.accept("./scatter.md?vue&type=template&id=3fe46919&", function () {
      api.rerender('3fe46919', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/scatter/scatter.md"
export default component.exports